// utils/laundryRequest.js
import axios from 'axios';
import { HTTP_CONFIG } from '@/config/config.js'

// 创建洗衣模块专用的 axios 实例
const laundryRequest = axios.create({
  baseURL: HTTP_CONFIG.API_laundry_URL,
  timeout: 10000
});

// 请求拦截器 - 自动添加 headers
laundryRequest.interceptors.request.use(
  (config) => {
    const headersStr = localStorage.getItem('laundry_headers');
    if (headersStr) {
      try {
        const customHeaders = JSON.parse(headersStr);
        config.headers = {
          ...config.headers,
          ...customHeaders
        };
      } catch (error) {
        console.error('解析 laundry_headers 失败:', error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default laundryRequest;